import { render } from "./OptinForm.vue?vue&type=template&id=beb6c1d6"
import script from "./OptinForm.vue?vue&type=script&lang=js"
export * from "./OptinForm.vue?vue&type=script&lang=js"

import "./OptinForm.vue?vue&type=style&index=0&id=beb6c1d6&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__